import React from 'react';
import OpcionDefecto from '../../../../Common/Components/OpcionDefecto';
import CheckDefecto from '../../../../Common/Components/CheckDefecto';
import ExpHelper from '../../../../Common/Helpers/ExpHelper';

const FormaDebito = ({ cuentaConDebitoEnDefault,tipoDebitoDefaultId, tipoDebitoDefaultInterfaz, formaPagoDebitos, seleccionoFormaPagoDebito, selectCheckBox, selectCombo }) => {
    const arrayAux = formaPagoDebitos.filter(d => d.Checked && d.Activo)
    const acentoLetraEminuscula = ExpHelper.ConvertirCaracter("e");
     

    return (
        <div className="row top-separator-xs">
            <div className="col-xs-12">
                <label className="label-primary">{"Forma de D" + acentoLetraEminuscula + "bito"}</label>
                
                {formaPagoDebitos.map((item) => {
                    const referencia = `GFB-${item.Id}`;
                    let inactivo = item.Descripcion.toLowerCase().match(/ inactivo/);
                    return (
                        ((item.Activo && !inactivo) || item.noDisponible) ?<CheckDefecto
                            key={item.Id}
                            nombre={item.Descripcion}
                            check={item.Checked}
                            activo={item.Activo}
                            referencia={referencia}
                            selectCheckBox={() => selectCheckBox("GET_FORMA_DEBITO", item.Id)} /> : null
                    )
                })}

                {cuentaConDebitoEnDefault && <OpcionDefecto
                    selecciono={arrayAux.length}
                    infoData={cuentaConDebitoEnDefault ? arrayAux : []}
                    referencia={"TipoDebitoDefaultId"}
                    valorCombo={tipoDebitoDefaultId}
                    valorChecked={tipoDebitoDefaultInterfaz}
                    selectCombo={(value) => selectCombo("TipoDebitoDefaultId", value)}
                    selectCheckBox={(value) => selectCheckBox("TipoDebitoDefaultInterfaz", value)}
                />}

                {(!seleccionoFormaPagoDebito && arrayAux.length===0)&&
                    <label className="error">{"Debe seleccionar al menos una forma de d" + acentoLetraEminuscula + "bito."}</label>}
            </div>
        </div>
    );
}

export default FormaDebito;